import './MatchableRates.scss';
import { MdOutlineSafetyDivider } from 'react-icons/md';
import { InfoTooltip } from '@Components/InfoTooltip/InfoTooltip';
import { Size } from '@Components/designConstants';

interface MatchableRatesProps {
  residentialResponseRates?: {
    residentialDeliveryRate: string;
    residentialResponseRate: string;
  };
}

export const MatchableRates = ({ residentialResponseRates }: MatchableRatesProps) => (
  <div className='matchable-rates-container'>
    <MdOutlineSafetyDivider />
    <div className='title'>Matchable Rates:</div>
    <div className='value'>Delivery: {residentialResponseRates?.residentialDeliveryRate}</div>
    <div className='value'>Response: {residentialResponseRates?.residentialResponseRate}</div>
    <InfoTooltip size={Size.MD}>
      Delivery: The percentage of total impressions that were delivered to matchable impressions.
      <br />
      <br />
      Response: The percentage of total responses that originated from matchable impressions.
    </InfoTooltip>
  </div>
);
